export default "__VITE_ASSET__ApvjOS5a__"